module Bookhus {

    interface ICardInformation {
        total: number;
        page: number;
        cards: ICard[];
    }

    interface ICard {
        id: number;
        imageId: string;
        title: string;
        body: string;
        publishDate: string;
        endDate: string;
        deactivate: boolean;
        link: string;
    }

    export class CarouselCardManager {

        private carouselContainer: JQuery;
        private cardContainer: JQuery;
        private contentSlider: JQuery;
        private autoStart: boolean;

        
        private currentSegment: number;
        private segmentSize: number;
        private totalSegments: number;

        private currentCardOffset: number;
        private cardWidth: number;
        private minCardWidth: number = 250;

        private timer: any;

        constructor() {            
            
        }

        public init(): void {
            var self = this;

            self.carouselContainer = $('.bootstrapCardCarousel:first');
            if (self.carouselContainer == null || self.carouselContainer.length == 0) {
                return;
            }

            self.cardContainer = self.carouselContainer.find('.cardContainer');
            if (self.cardContainer == null || self.cardContainer.length == 0) {
                return;
            }

            self.contentSlider = self.carouselContainer.find('.cardContainer .contentSlider');
            if (self.contentSlider == null || self.contentSlider.length == 0) {
                return;
            }

            self.autoStart = self.carouselContainer.attr('data-autostart') == "true";
            self.segmentSize = self.tryParse(self.carouselContainer.attr('data-pagesize'), 4);

            self.currentCardOffset = 0;
            self.cardWidth = self.calculateCardWidth(self.segmentSize);
            self.currentSegment = 0;
            self.totalSegments = 1;

            self.loadNextSegment();            
            self.initEvents();
            if (self.autoStart) {
                self.initTimer();
            }
        }

        private loadNextSegment(callback: () => void = null) {
            var self = this;

            if (self.currentSegment >= self.totalSegments) {
                return;
            }

            var nextSegment = self.currentSegment + 1;

            var ajax = $.ajax({
                url: '/api/carouselcard/getcards',
                type: 'get',
                dataType: 'json',
                data: {
                    page: nextSegment,
                    pageSize: self.segmentSize
                }
            });

            ajax.then((cardInformation: ICardInformation) => {
                self.currentSegment = nextSegment;
                self.totalSegments = Math.ceil(cardInformation.total / self.segmentSize);
                self.resizeSegment(false);
                self.drawSegment(cardInformation.cards);
                if (!self.IsThereMoreSegmentsToLoad() && self.totalSegments == 1) {
                    $('.nav-arrow', self.carouselContainer).css('display', 'none');
                }
                if (typeof (callback) == "function") {
                    callback();
                }
            });

            ajax.fail(() => {
                self.drawEmptySegment();
            });
        }

        private drawSegment(cards: ICard[]) {
            var self = this;

            for (var index = 0; index < cards.length; index++) {
                var current = cards[index];

                var card = $(`
                    <div class="col-md-3" style="width: ${self.cardWidth}px; max-width: none;">
                        <div class="bthumbnail ${current.link ? 'hasLink' : ''}">
                            <div class="bthumbnail-img" style="background-image: url('/siteimage/${current.imageId}')"></div>
                            <div class="caption brand-background ${self.segmentSize <= 2 ? 'large' : ''}">
                                <h3>${current.title}</h3>
                                <p>${current.body}</p>
                            </div>
                        </div>
                    </div>
                `);
                card.prop('redirectUrl', current.link);
                card.on('click', (e) => {
                    var target = $(e.currentTarget);
                    if (target == null || target.length == 0) {
                        return;
                    }

                    var redirectUrl = target.prop('redirectUrl');
                    if (redirectUrl == null || redirectUrl == undefined || redirectUrl == "") {
                        return;
                    }
                    window.location.href = redirectUrl;
                });
                self.contentSlider.append(card);
            }
        }

        private drawEmptySegment(): void {
            var self = this;
            self.contentSlider.html(`
                <div class="col-md-3" style="width: ${self.cardWidth}px">
                    <div class="bthumbnail">
                        <div class="bthumbnail-img" style="background-image: url('/content/siteimages/news.jpg'); background-size: contain;"></div>
                        <div class="caption brand-background ${self.segmentSize <= 2 ? 'large' : ''}">
                            <h3>Ingen nyheder</h3>
                            <p></p>
                        </div>
                    </div>
                </div>
            `);
        }

        initEvents(): void {
            var self = this;
            self.carouselContainer.find('.nav-arrow-left').on('click', () => {
                self.MoveToNextCard(-1);
                self.clearTimer();
            });

            self.carouselContainer.find('.nav-arrow-right').on('click', () => {
                self.MoveToNextCard(1);
                self.clearTimer();                
            });

            $(window).on('resize', self.debounce(() => { self.resizeSegment(); }, 50, false));
        }

        initTimer() {
            var self = this;
            self.timer = setInterval(() => {
                if (self.currentCardOffset >= self.totalSegments * self.segmentSize || self.totalSegments <= 1) {
                    self.clearTimer();
                    return;
                }
                self.MoveToNextCard(1);
            }, 1000 * 10);
        }

        clearTimer() {
            var self = this;
            clearInterval(self.timer);
        }

        private tryParse(input: string, defaultValue: number): number {
            if (input != null || input != undefined || input.length != 0) {
                var result = parseInt(input);
                if (!isNaN(result)) {
                    return result;
                }
            }
            return defaultValue;
        }

        private IsThereMoreCardsToShow(): boolean {
            var self = this;

            var cardsDisplayablePerSegment = Math.floor(self.cardContainer.width() / self.cardWidth);
            var totalCardsToDisplay = self.contentSlider.children('.col-md-3').length - cardsDisplayablePerSegment;
            return totalCardsToDisplay - self.currentCardOffset > 0;
        }

        private IsThereMoreSegmentsToLoad(): boolean {
            var self = this;
            return self.currentSegment < self.totalSegments;
        }

        private MoveToNextCard(direction: number): void {
            var self = this;
            
            if (self.contentSlider.is(':animated')) {
                return;
            }

            var newCardOffset = self.currentCardOffset + direction;
            if (newCardOffset < 0) {
                return;
            }

            //We only want to do these cheks if we're moving forward
            if (direction > 0 && !self.IsThereMoreCardsToShow()) {
                if (self.IsThereMoreSegmentsToLoad()) {
                    self.loadNextSegment(() => {
                        self.MoveToNextCard(direction);
                    });
                    return;
                }
                newCardOffset = 0;
            }

            self.currentCardOffset = newCardOffset;
            self.contentSlider.animate({ marginLeft: -self.convertCardOffsetToWidth(newCardOffset) }, 500);
        }

        private convertCardOffsetToWidth(cardOffset: number): number {
            var self = this;
            return cardOffset * self.cardWidth;
        }

        private resizeSegment(animate = true): void {
            var self = this;
            self.cardWidth = self.calculateCardWidth(self.segmentSize);
            self.contentSlider.children('div.col-md-3').css('width', self.cardWidth);
            self.contentSlider.css('width', Math.ceil(self.cardWidth * self.currentSegment * self.segmentSize));
            if (animate) {
                self.contentSlider.animate({ marginLeft: -self.convertCardOffsetToWidth(self.currentCardOffset) }, 500);
            }
        }

        private calculateCardWidth(maxDisplayableCards: number): number {
            var self = this;
            var cardWidth = Math.floor(self.cardContainer.width() / maxDisplayableCards);
            if (cardWidth < self.minCardWidth && maxDisplayableCards > 1) {
                return self.calculateCardWidth(--maxDisplayableCards);
            }
            return cardWidth;
        }

        private debounce(func, wait, immediate) {
            var timeout;
            return function () {
                var context = this, args = arguments;
                var later = function () {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        }
    }
}

var carouselCardManager = new Bookhus.CarouselCardManager();
carouselCardManager.init();